import { createApp } from 'vue';
import App from './App.vue';
import router from './router';
import store from './store';
import ElementPlus from 'element-plus';
import 'element-plus/dist/index.css';
import zhCn from 'element-plus/es/locale/lang/zh-cn';
import { loadScript } from '@/utils/utils';

const app = createApp(App).use(store).use(router);
app.use(ElementPlus, {
  locale: zhCn,
});
app.mount('#app');
// app.config.globalProperties.$http = fly;

if (origin.includes('tengmed.com') || origin.includes('localhost')) {
  loadScript('https://turing.captcha.qcloud.com/TCaptcha.js');
}
